import { useState } from 'react'
import type { OperationsNode } from '@sportninja/common/features/competition/operations/types/operations.types'

export interface TreeSelection {
  selectedId: string | null
  setSelectedId: (id: string | null) => void
  selectedNode: OperationsNode | null
  /** Root-first path to the selected node, excluding the node itself. */
  ancestors: OperationsNode[]
}

const findPath = (
  nodes: OperationsNode[],
  id: string,
  trail: OperationsNode[] = []
): OperationsNode[] | null => {
  for (const node of nodes) {
    if (node.id === id) {
      return [...trail, node]
    }
    const found = findPath(node.children, id, [...trail, node])
    if (found) {
      return found
    }
  }
  return null
}

/**
 * Tracks which node the panel is showing. Selection is stored by id rather
 * than by object so it survives a tree refetch — the node identity changes on
 * every rebuild, the id does not.
 */
export const useTreeSelection = (nodes: OperationsNode[]): TreeSelection => {
  'use memo'

  const [selectedId, setSelectedId] = useState<string | null>(null)

  const path = selectedId ? findPath(nodes, selectedId) : null
  const selectedNode = path ? path[path.length - 1] : null
  const ancestors = path ? path.slice(0, -1) : []

  return { selectedId, setSelectedId, selectedNode, ancestors }
}
